jQuery(function ($) { // wait for document ready
    if ($('.about-us-page').length) {
    }

    function commaSeparateNumber(val) {
        while (/(\d+)(\d{3})/.test(val.toString())) {
            val = val.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
        }
        return val;
    }

    function checkCounterVisibility() {
        $('.counter').each(function() {
            if ($(this).data('animated'))
                return true;
            var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
            var top_of_screen = $(window).scrollTop();
            var top_of_element = $(this).offset().top;
            var bottom_of_element = $(this).offset().top + $(this).outerHeight();
            if (bottom_of_screen > top_of_element && top_of_screen < bottom_of_element) {
                var $this = $(this),
                    countTo = $this.attr('data-count');

                $this.data('animated',true);

                $({
                    countNum: $this.text()
                }).animate({
                        countNum: countTo
                    },

                    {
                        duration: 1500,
                        easing: 'linear',
                        step: function () {
                            $this.text(commaSeparateNumber(Math.floor(this.countNum)));
                        },
                        complete: function () {
                            $this.text(commaSeparateNumber(this.countNum));
                            //alert('finished');
                        }
                    }
                );
            }
        });
    }

    $(window).on('scroll', checkCounterVisibility);
});